import dayjs from "dayjs";
import { content } from "../constants/content";

export default function trans(id) {
  const lang = localStorage.getItem("lang") || "en";
  const item = content.find((el) => el.id === id);
  return item ? item[lang] : id;
}

export const isRTL = localStorage.getItem("lang") === "ar";

export function convertMillisecondsToTime(ms) {
  const totalMinutes = Math.floor(ms / 60000); // Convert ms to minutes
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (isRTL) {
    return `${hours}س ${minutes}د`;
  } else {
    return `${hours}h ${minutes}m`;
  }
}

export function knotsToKmPerHour(knots) {
  return knots * 1.852;
}

export const formatTime = (timeInSeconds) => {
  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor((timeInSeconds % 3600) / 60);
  const seconds = Math.floor(timeInSeconds % 60);

  if (hours > 0) {
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}`;
  }
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
    2,
    "0"
  )}`;
};

export function formatTimeOnly(timeStr) {
  if (!timeStr) return "";

  const [hoursStr, minutesStr] = timeStr.split(":");
  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);

  if (isNaN(hours) || isNaN(minutes)) return timeStr;

  const period = hours >= 12 ? "PM" : "AM";
  const adjustedHour = hours % 12 || 12;

  return `${adjustedHour.toString().padStart(2, "0")}:${minutesStr} ${period}`;
}

export function formatTimeFromDate(timeStr) {
  if (!timeStr) return "";

  const date = new Date(timeStr);
  if (isNaN(date.getTime())) return timeStr;

  // Get hours and minutes in UTC to avoid timezone shift
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
}

export function formatSize(bytes) {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
}

export const getDateColor = ({ date }) => {
  const today = dayjs().startOf("day");
  const diff = date.startOf("day").diff(today, "day");

  if (diff < 0) {
    return "red";
  } else if (diff <= 5) {
    return "yellow";
  } else {
    return "default";
  }
};

export const formatDuration = (totalMinutes) => {
  const days = Math.floor(totalMinutes / (24 * 60));
  const hours = Math.floor((totalMinutes % (24 * 60)) / 60);
  const minutes = totalMinutes % 60;

  const parts = [];
  if (days > 0) parts.push(`${days}d`);
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0 || parts.length === 0) parts.push(`${minutes}m`);

  return parts.join(" ");
};

export function splitDateTime(dateStr) {
  if (!dateStr) return { date: "", time: "" };

  const date = dayjs(dateStr);
  if (!date.isValid()) return { date: "", time: "" };

  const lang = localStorage.getItem("lang") || "en";

  const formattedDate = date.format("DD/MM/YYYY");

  const formattedTime = date.format("hh:mm A");

  return { date: formattedDate, time: formattedTime };
}

export function formatDateTime(dateStr) {
  if (!dateStr) return "";

  const date = dayjs(dateStr);
  if (!date.isValid()) return "";

  return date.format("MMM D, YYYY HH:mm");
}

export const formatDateForAPI = (date) => {
  if (!date) return null;
  const d = new Date(date);

  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const seconds = String(d.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};

export const getLateLimitInMinutes = (threshold, unit) => {
  if (!threshold) return 0;
  return unit === "hr" ? threshold * 60 : threshold;
};

export const calculateDelayDuration = (startTime) => {
  if (!startTime) return "- - -";

  const start = new Date(startTime);
  const now = new Date();

  const diffMs = now - start; // milliseconds difference
  if (diffMs <= 0) return "0m";

  const totalMinutes = Math.floor(diffMs / 60000);
  return formatDuration(totalMinutes);
};
